import { useEffect, useState } from "react";
import { useSessionApiClient } from "../api/sessions";
import Table from "@mui/material/Table";
import { Link, Paper, TableContainer } from "@mui/material";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import timestampToHuman from "../utils/date";

const renderSessionsList = (sessionsList) => {
  return (
    <>
      <h1>Existing sessions</h1>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Session ID</TableCell>
              <TableCell align="right">Created At</TableCell>
              <TableCell align="right">Updated At</TableCell>
              <TableCell align="right">Input Parquet File</TableCell>
              <TableCell align="right">Images Base Path</TableCell>
              <TableCell align="right">Status</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sessionsList.map((session) => (
              <TableRow
                key={session.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {session.id}
                </TableCell>
                <TableCell align="right">
                  {timestampToHuman(session.createdAt)}
                </TableCell>
                <TableCell align="right">
                  {timestampToHuman(session.updatedAt)}
                </TableCell>
                <TableCell align="right">{session.inputParquetFile}</TableCell>
                <TableCell align="right">{session.imagesBasePath}</TableCell>
                <TableCell align="right">{session.status === "pending" ? `${session.initProgress}%` : session.status}</TableCell>
                <TableCell align="right">
                  <Link href={`/sessions/${session.id}`}>Open Session</Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

const SessionsList = () => {
  const [sessionsList, setSessionsList] = useState([]);
  const apiSessionClient = useSessionApiClient();

  useEffect(() => {
    const fetchSessions = async () => {
      const sessions = await apiSessionClient.getSessions();
      setSessionsList(sessions);
    };

    fetchSessions();
  }, []);

  return (
    <>{sessionsList.length > 0 ? renderSessionsList(sessionsList) : <></>}</>
  );
};

export default SessionsList;
